import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import { Schedule } from '@/types/schedule';

const basePath = '/api/schedules';

export const scheduleRepository = createRepository<Schedule, Schedule>(basePath);

const ScheduleRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list() {
      return scheduleRepository.listNoPagination({ host, params: {} });
    }
  };
};

export default ScheduleRepository;
